import React from 'react'
import type { EquityFormData } from 'submission/lib/equity-form-defaults'

type Props = {
  form: EquityFormData
  setForm: React.Dispatch<React.SetStateAction<EquityFormData>>
  errors: Record<string, string>
}

const FIELDS: Array<{ key: keyof EquityFormData; label: string }> = [
  { key: 'depositStarts', label: 'Deposit starts' },
  { key: 'depositEnds', label: 'Deposit ends' },
  { key: 'shortlistNotified', label: 'Shortlist notified' },
  { key: 'signAgreement', label: 'Sign agreement deadline' },
  { key: 'firstUnlock', label: 'First unlock' },
  { key: 'nftTransferable', label: 'NFT transferable' },
]

const TimelineSection: React.FC<Props> = ({ form, setForm, errors }) => {
  return (
    <section className="bg-white border border-slate-200 rounded p-6">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">Timeline</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {FIELDS.map((f) => (
          <label key={f.key} className="flex flex-col text-sm">
            <span className="text-slate-700 mb-1">{f.label} *</span>
            <input
              type="datetime-local"
              className="border rounded px-2 py-1 text-slate-900 bg-white"
              value={form[f.key] as string}
              onChange={(e) =>
                setForm((p) => ({ ...p, [f.key]: e.target.value }))
              }
            />
          </label>
        ))}
      </div>
      {errors.timelines && (
        <p className="text-red-600 text-xs mt-2">{errors.timelines}</p>
      )}
    </section>
  )
}

export default TimelineSection
